import { render } from "./CmsTabContainerComponent.vue?vue&type=template&id=3127e871&scoped=true"
import script from "./CmsTabContainerComponent.vue?vue&type=script&lang=js"
export * from "./CmsTabContainerComponent.vue?vue&type=script&lang=js"

import "./CmsTabContainerComponent.vue?vue&type=style&index=0&id=3127e871&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3127e871"]])

export default __exports__